import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const EducationBackground = () => {
  const education = [
  {
  degree: "BSc (Hons) Computer Science and Software Engineering",
  institution: "University of Bolton",
  location: "Greater Manchester, UK",
  period: "2023-2026",
  gpa: "3.9/4.0",
    honors: "",
    logo: "https://tse4.mm.bing.net/th/id/OIP.V543by55E9-aYWG64len-gAAAA?rs=1&pid=ImgDetMain&o=7&rm=3",
    logoAlt: "University of Bolton logo with blue and gold branding",
  description: "Studied Computer Science at the University of Bolton, focusing on software engineering, web development, and artificial intelligence. Led open source initiatives and contributed to GitHub projects throughout my studies.",
    coursework: [
    "Advanced Algorithms & Data Structures",
    "Full-Stack Web Development",
    "Cloud Computing",
    "Machine Learning & AI",
    "Database Systems",
    "DevOps & Automation",
    "Cybersecurity Fundamentals",
    "Mobile App Development"],

    projects: [
    "Open source task management app (GitHub, 1K+ stars)",
    "AI-powered analytics dashboard for developers",
    "Real-time chat platform using React and Node.js"],

    achievements: [
    "Top GitHub contributor in university cohort",
    "Founded university open source club (300+ members)",
    "Published research on AI for developer productivity",
    "Won 4 hackathon competitions"]

  }];


  const certifications = [
    // Non-Google certificates (top)
    {
      name: 'Full Stack Open',
      issuer: 'University of Helsinki',
      credentialId: '05c08a72413e62f48fd8ced3d1346bc8',
      logo: 'https://cdn.simpleicons.org/react/61DAFB',
      logoAlt: 'React logo',
      skills: ['React', 'Node.js', 'GraphQL', 'MongoDB', 'Testing', 'TypeScript']
    },
    {
      name: 'Full Stack Open - TypeScript',
      issuer: 'University of Helsinki',
      credentialId: 'fs-typescript',
      logo: 'https://cdn.simpleicons.org/typescript/3178C6',
      logoAlt: 'TypeScript logo',
      skills: ['TypeScript', 'Types', 'Generics', 'Type-Safe React']
    },
    {
      name: 'Full Stack Open - GraphQL',
      issuer: 'University of Helsinki',
      credentialId: 'a026a126830407d4d7d42ff2c2679776',
      logo: 'https://cdn.simpleicons.org/graphql/E10098',
      logoAlt: 'GraphQL logo',
      skills: ['GraphQL', 'API Development', 'Apollo Server', 'Schema Design']
    },
    {
      name: 'Full Stack Open - Relational Databases',
      issuer: 'University of Helsinki',
      credentialId: 'a1de6f8d2d0000713f83df27e8640dea',
      logo: 'https://cdn.simpleicons.org/postgresql/4169E1',
      logoAlt: 'PostgreSQL logo',
      skills: ['PostgreSQL', 'SQL', 'Relational Modeling', 'Schema Design', 'Indexes']
    },
    {
      name: 'Full Stack Open - CI/CD',
      issuer: 'University of Helsinki',
      credentialId: '71fb76a703baeddb895fcb2075ea4570',
      logo: 'https://cdn.simpleicons.org/githubactions/2088FF',
      logoAlt: 'GitHub Actions logo',
      skills: ['CI/CD', 'GitHub Actions', 'Automated Testing', 'Deployment Pipelines']
    },
    {
      name: 'Full Stack Open - React Native',
      issuer: 'University of Helsinki',
      credentialId: '5a5ca336593b972f8db79c573c34de55',
      logo: 'https://cdn.simpleicons.org/react/61DAFB',
      logoAlt: 'React logo',
      skills: ['React Native', 'Mobile Development', 'Cross-Platform Apps', 'JavaScript']
    },
    {
      name: 'Java Programming I',
      issuer: 'University of Helsinki',
      credentialId: 'qhpg15d1gkl',
      logo: 'https://pngset.com/images/java-logo-image-symbol-trademark-ketchup-food-transparent-png-1949390.png',
      logoAlt: 'Java logo',
      skills: ['Java', 'Object-Oriented Programming', 'Algorithms', 'Data Structures']
    },
    {
      name: 'Java Programming II',
      issuer: 'University of Helsinki',
      credentialId: '8bab5wi0yot',
      logo: 'https://pngset.com/images/java-logo-image-symbol-trademark-ketchup-food-transparent-png-1949390.png',
      logoAlt: 'Java logo',
      skills: ['Advanced Java', 'Collections', 'File I/O', 'Exception Handling']
    },
    {
      name: 'Ethics of AI',
      issuer: 'University of Helsinki',
      credentialId: 'ai-ethics-cert',
      logo: 'https://cdn.simpleicons.org/bookstack/0288D1',
      logoAlt: 'BookStack logo',
      skills: ['AI Ethics', 'Responsible AI', 'AI Policy', 'Ethical Decision Making']
    },
    // Google certificates (bottom)
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '2d4f565c-ffe2-4ae4-8b4d-3b1fb5100604',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization', 'Measurement']
    },
    {
      name: 'Google Analytics Certification',
      issuer: 'Google Skillshop',
      credentialId: 'f6b844b9-7a98-41bf-8cc6-659e050054ae',
      logo: 'https://cdn.simpleicons.org/googleanalytics/E37400',
      logoAlt: 'Google Analytics logo',
      skills: ['GA4', 'Measurement', 'Reporting']
    },
    {
      name: 'AI-Powered Performance Ads Certification',
      issuer: 'Google Skillshop',
      credentialId: 'da103005-0cbb-4cd4-8edf-4bd8c1d8b00e',
      logo: 'https://cdn.simpleicons.org/googleads/4285F4',
      logoAlt: 'Google Ads logo',
      skills: ['AI Automation', 'Cross-Channel Ads', 'Optimization']
    },
    {
      name: 'Grow Offline Sales Certification',
      issuer: 'Google Skillshop',
      credentialId: '19fbbef3-1280-42d8-82cc-d7d8ee19ec35',
      logo: 'https://cdn.simpleicons.org/googleads/4285F4',
      logoAlt: 'Google Ads logo',
      skills: ['Offline Sales', 'Performance Max', 'Measurement']
    },
    {
      name: 'Campaign Manager 360 Certification Exam',
      issuer: 'Google Skillshop',
      credentialId: '2ca92a7a-2799-4fec-b906-ee192f9831a0',
      logo: 'https://cdn.simpleicons.org/googlemarketingplatform/1A73E8',
      logoAlt: 'Google Marketing Platform logo',
      skills: ['Trafficking', 'Tagging', 'Reporting']
    },
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '4759a3aa-a718-4838-a6f2-97fe324b6f00',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization']
    },
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '62b1ade2-8612-4165-8f98-65c0a70955ab',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization']
    },
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '04fb68b6-486e-4bff-86f5-29864f8894f6',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization']
    },
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '5d01c961-aea3-415c-ae4e-99df88fc9232',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization']
    },
    {
      name: 'Google Skillshop Certification',
      issuer: 'Google Skillshop',
      credentialId: '9fd5eaf4-26e0-485a-8766-4a4692a2d74d',
      logo: 'https://cdn.simpleicons.org/google/4285F4',
      logoAlt: 'Google logo',
      skills: ['Google Ads', 'Optimization']
    }
  ];


  const continuousLearning = [
  {
    platform: "Coursera",
    courses: 15,
    hours: 240,
    recentCourse: "Advanced Machine Learning Specialization",
    logo: "https://images.unsplash.com/photo-1650064175560-369b5b45b649",
    logoAlt: "Coursera online learning platform logo with blue graduation cap icon"
  },
  {
    platform: "Udemy",
    courses: 28,
    hours: 180,
    recentCourse: "Complete Node.js Developer Course",
    logo: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0",
    logoAlt: "Udemy educational platform logo with purple and pink gradient design"
  },
  {
    platform: "Pluralsight",
    courses: 22,
    hours: 160,
    recentCourse: "Advanced React Patterns",
    logo: "https://images.unsplash.com/photo-1576040568135-1a8e30961c52",
    logoAlt: "Pluralsight technology learning logo with orange geometric shapes on white background"
  }];


  return (
    <section className="py-20 lg:py-32 bg-muted/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="GraduationCap" size={16} />
            <span>Education & Learning</span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">
            Academic Foundation &
            <span className="text-gradient-brand block">Continuous Growth</span>
          </h2>
          
          <p className="text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            My educational journey combines formal computer science education with continuous learning 
            and professional certifications to stay at the forefront of technology.
          </p>
        </div>

        {/* Formal Education */}
        <div className="mb-20">
          <h3 className="text-2xl lg:text-3xl font-bold text-foreground mb-8 text-center">
            Formal Education
          </h3>
          
          {education?.map((edu, index) => (
          <div key={index} className="bg-card border border-border rounded-3xl p-8 lg:p-12 shadow-brand-sm">
              <div className="grid lg:grid-cols-3 gap-8">
                {/* Institution Info */}
                <div className="lg:col-span-1">
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-16 h-16 rounded-2xl overflow-hidden border border-border">
                      <Image
                      src={edu?.logo}
                      alt={edu?.logoAlt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-card-foreground">
                        {edu?.institution}
                      </h4>
                      <p className="text-muted-foreground">{edu?.location}</p>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-2">
                      <Icon name="Calendar" size={16} className="text-primary" />
                      <span className="text-sm text-muted-foreground">{edu?.period}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Award" size={16} className="text-success" />
                      <span className="text-sm text-muted-foreground">GPA: {edu?.gpa}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Star" size={16} className="text-warning" />
                      <span className="text-sm text-muted-foreground">{edu?.honors}</span>
                    </div>
                  </div>
                </div>

                {/* Degree & Description */}
                <div className="lg:col-span-2">
                  <h4 className="text-2xl font-bold text-card-foreground mb-4">
                    {edu?.degree}
                  </h4>
                  
                  <p className="text-muted-foreground mb-6 leading-relaxed">
                    {edu?.description}
                  </p>

                  {/* Coursework */}
                  <div className="mb-6">
                    <h5 className="text-lg font-semibold text-card-foreground mb-3 flex items-center space-x-2">
                      <Icon name="BookOpen" size={18} className="text-primary" />
                      <span>Relevant Coursework</span>
                    </h5>
                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
                      {edu?.coursework?.map((course, idx) => (
                    <div key={idx} className="bg-muted text-muted-foreground px-3 py-2 rounded-lg text-sm">
                          {course}
                        </div>
                    ))}
                    </div>
                  </div>

                  {/* Key Projects */}
                  <div className="mb-6">
                    <h5 className="text-lg font-semibold text-card-foreground mb-3 flex items-center space-x-2">
                      <Icon name="Code2" size={18} className="text-accent" />
                      <span>Key Projects</span>
                    </h5>
                    <ul className="space-y-2">
                      {edu?.projects?.map((project, idx) => (
                    <li key={idx} className="flex items-start space-x-2 text-muted-foreground">
                          <Icon name="ArrowRight" size={16} className="text-accent mt-0.5 flex-shrink-0" />
                          <span>{project}</span>
                        </li>
                    ))}
                    </ul>
                  </div>

                  {/* Achievements */}
                  <div>
                    <h5 className="text-lg font-semibold text-card-foreground mb-3 flex items-center space-x-2">
                      <Icon name="Trophy" size={18} className="text-warning" />
                      <span>Academic Achievements</span>
                    </h5>
                    <ul className="space-y-2">
                      {edu?.achievements?.map((achievement, idx) => (
                    <li key={idx} className="flex items-start space-x-2 text-muted-foreground">
                          <Icon name="CheckCircle" size={16} className="text-success mt-0.5 flex-shrink-0" />
                          <span>{achievement}</span>
                        </li>
                    ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Professional Certifications */}
        <div className="mb-20">
          <h3 className="text-2xl lg:text-3xl font-bold text-foreground mb-8 text-center">
            Professional Certifications
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {certifications?.map((cert, index) => (
            <div key={index} className="bg-card border border-border rounded-2xl p-6 hover-lift transition-brand">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 rounded-xl overflow-hidden border border-border flex-shrink-0">
                    <Image
                    src={cert?.logo}
                    alt={cert?.logoAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-card-foreground mb-1">
                      {cert?.name}
                    </h4>
                    <p className="text-accent font-medium mb-1">{cert?.issuer}</p>
                    <p className="text-sm text-muted-foreground">
                      Issued: {cert?.date} • ID: {cert?.credentialId}
                    </p>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-2">
                  {cert?.skills?.map((skill, idx) => (
                <span
                  key={idx}
                  className="bg-primary/10 text-primary px-2 py-1 rounded text-xs font-medium">

                      {skill}
                    </span>
                ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Continuous Learning */}
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-foreground mb-8 text-center">
            Continuous Learning Journey
          </h3>
          
          <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-success/5 rounded-3xl p-8 lg:p-12">
            <div className="text-center mb-8">
              <p className="text-lg text-muted-foreground">
                Committed to staying current with the latest technologies and best practices
              </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              {continuousLearning?.map((platform, index) => (
              <div key={index} className="text-center">
                  <div className="w-16 h-16 rounded-2xl overflow-hidden border border-border mx-auto mb-4">
                    <Image
                    src={platform?.logo}
                    alt={platform?.logoAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  
                  <h4 className="text-xl font-bold text-foreground mb-2">
                    {platform?.platform}
                  </h4>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-center space-x-6 text-sm text-muted-foreground">
                      <span>{platform?.courses} Courses</span>
                      <span>{platform?.hours}+ Hours</span>
                    </div>
                  </div>
                  
                  <p className="text-sm text-muted-foreground">
                    Latest: {platform?.recentCourse}
                  </p>
                </div>
              ))}
            </div>
            
            {/* Learning Stats */}
            <div className="mt-12 pt-8 border-t border-border/50">
              <div className="grid grid-cols-3 gap-8 text-center">
                <div>
                  <div className="text-3xl font-bold text-primary mb-2">70+</div>
                  <div className="text-sm text-muted-foreground">Courses Completed</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-accent mb-2">580+</div>
                  <div className="text-sm text-muted-foreground">Learning Hours</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-success mb-2">19+</div> 
                  <div className="text-sm text-muted-foreground">Certifications</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default EducationBackground;
